import swal from "sweetalert";
import {tr} from "./i18n.js";

export default class SweetAlertHelper {
    static showInvalidFields() {
        swal({
            title: tr(`Invalid fields|Champs non valides`),
            text: tr(`Some fields are missing or invalid|Certains champs sont manquant ou non valides`),
            icon: `info`
        });
    }

    static showLoading(title, text, percent = null, showPercentage = true) {
        let content = null;
        let icon = `https://eyeinlivestorage.blob.core.windows.net/public/icons/loading.gif`;
        if (percent) {
            icon = null;
            content = document.createElement(`div`);
            content.className = `loading-container`;

            if (showPercentage) {
                let percentageDiv = document.createElement(`div`);
                percentageDiv.className = `percentage-value`
                percentageDiv.innerHTML = `${Math.round(percent)}%`;
                content.appendChild(percentageDiv);
            }

            let progress = document.createElement(`div`);
            progress.className = `progress sm`;
            let progressBar = document.createElement(`div`);
            progressBar.className = `progress-bar`;
            progressBar.style.width = percent + `%`;
            progress.appendChild(progressBar);
            content.appendChild(progress);

            let loadingIcon = document.createElement(`i`);
            loadingIcon.className = `float-right fas fa-spinner-third fa-spin`;
            loadingIcon.style.animationIterationCount = `1`;
            loadingIcon.style.animationDuration = `2s`;
            loadingIcon.style.animationTimingFunction = `ease-in-out`;
            content.appendChild(loadingIcon);
        }
        swal({
            title: title ? tr(title) : tr(`In progress|En cours`),
            text: text ? tr(text) : tr(`Please wait...|Merci de patienter...`),
            content: content,
            icon: icon,
            closeOnEsc: false,
            closeOnClickOutside: false,
            buttons: false
        });
    }

    static showErrorMessage(title, text) {
        swal({
            title: title ? tr(title) : tr(`Error|Erreur`),
            text: text ? tr(text) : tr(`You are not allowed to do this action or there is no data|Vous n'avez pas la permission d'effectuer cette action ou il n'y a aucune donnée`),
            icon: `error`
        });
    }

    static showErrorFeedback(networkFeedback) {
        let title = networkFeedback.title ? tr(networkFeedback.title) : tr(`Error|Erreur`);
        if (networkFeedback.code) {
            title += ` ${networkFeedback.code}`;
        }

        swal({
            title: title,
            text: networkFeedback.description ? tr(networkFeedback.description) : tr(`You are not allowed to do this action or there is no data|Vous n'avez pas la permission d'effectuer cette action ou il n'y a aucune donnée`),
            icon: networkFeedback.icon || `error`
        });
    }

    static showRenamePrompt(title, message, defaultValue, confirmText, icon, callback) {
        swal({
            title: title ? tr(title) : tr(`Rename|Renommer`),
            text: message ? tr(message) : tr(`Enter the new name for '${defaultValue}'|Entrez le nouveau nom pour '${defaultValue}'`),
            icon: icon || `info`,
            content: {
                element: `input`,
                attributes: {
                    defaultValue: defaultValue
                }
            },
            buttons: {
                cancel: true,
                confirm: {
                    text: confirmText ? tr(confirmText) : tr(`Rename|Renommer`),
                    closeModal: false
                }
            }
        }).then(name => {
            if (!name || name === defaultValue) {
                swal.close();
                return;
            }
            if (callback) {
                callback(name);
                swal.close();
            }
        });
    }

    static hideLoading() {
        swal.close();
    }

    static showSavedMessage(title, text, callback) {
        swal({
            title: title ? tr(title) : tr(`Saved|Enregistré`),
            text: text ? tr(text) : null,
            icon: `success`
        }).then(() => {
            if (typeof callback === `function`) {
                callback();
            }
        });
    }

    static showCreatedMessage(itemName = `The item|L'élément`, callback) {
        swal({
            title: tr(`Created|Ajouté`),
            text: tr(`${itemName} has been created successfully|${itemName} a été créé avec succès`),
            icon: `success`
        }).then(() => {
            if (typeof callback === `function`) {
                callback();
            }
        });
    }

    static showConfirmationMessage(confirmTitle = `Confirm|Confirmer`, confirmText = `Are you sure?|Êtes-vous sûr ?`, buttonText = `Confirm|Confirmer`, buttonClass = ``, icon = `warning`) {
        return swal({
            title: tr(confirmTitle),
            text: tr(confirmText),
            icon: icon || `warning`,
            buttons: {
                cancel: tr(`Cancel|Annuler`),
                confirm: {
                    text: tr(buttonText),
                    className: buttonClass
                }
            }
        })
    }
}
